export interface BeltInfo {
  id: string;
  levelNo: number;
  levelName: string;
  color: string;
  xpThreshold: number;
}

export interface UserProfile {
  id: string;
  username: string;
  totalXp: number;
  lastTrainingDate: string | null;
  hasTrainedToday: boolean;
  createdAt: string;
  currentBelt: BeltInfo | null;
  xpToNextBelt: number | null;
  nextBeltXpThreshold: number | null;
  nextBeltCurriculumTotal: number | null;
  nextBeltCurriculumMastered: number | null;
}

export interface UserProgressItem {
  id: string;
  curriculumId: string;
  curriculumName: string;
  masteryLevel: number;
  lastPracticed: string | null;
}

/** Response from GET /User/{id}/TrainingDays. Dates are ISO-8601 "YYYY-MM-DD" strings. */
export interface TrainingHistory {
  trainingDays: string[];   // e.g. ["2025-05-01", "2025-05-02", ...]
  totalDays: number;
}

// MasteryLevel 0–5 display labels
export const MASTERY_LABELS: Record<number, string> = {
  0: 'Ukendt',
  1: 'Hørt om',
  2: 'Bekendt',
  3: 'Kender',
  4: 'Husket',
  5: 'Kan udenad',
};
